// extracted by mini-css-extract-plugin
var _1 = "EstimateShipping__container--CWffZ OfficeGeneral__tBackground--Z3C57 OfficeGeneral__bgLightGray--uru7V";
var _2 = "EstimateShipping__extra--d9Txk OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _3 = "EstimateShipping__main--FAxmo";
var _4 = "EstimateShipping__price--YTnwJ OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _5 = "EstimateShipping__tRow--HgPr5";
var _6 = "EstimateShipping__table--fLhuU";
var _7 = "EstimateShipping__time--gquyh OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _8 = "EstimateShipping__title--j3Xin OfficeGeneral__textSizeA--ZYpjj CoreGeneral__textSizeA--JbJdW OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
var _9 = "EstimateShipping__type--O3cvJ";
var _a = "EstimateShipping__typePrice--Ue_10";
export { _1 as "container", _2 as "extra", _3 as "main", _4 as "price", _5 as "tRow", _6 as "table", _7 as "time", _8 as "title", _9 as "type", _a as "typePrice" }
